import React, {useCallback, useState} from "react";
import {DialogContent} from "@mui/material";
import Button from "../../../../../base/button/button";
import AssignedItemsListProductsTab from "./tabs/products";
import AssignedItemsListCategoriesTab from "./tabs/categories";
import {Tab, Tabs} from "../../../../../base/Tabs";
import useIsMounted from "../../../../../../hooks/use-is-mounted";
import {Add} from "@mui/icons-material";

const AssignedItemsList = ({technicalFileId, setInAddMode, assign, unAssign}) => {
    const [tab, setTab] = useState(0);
    const [categories, setCategories] = useState([]);
    const [loadingCategories, setLoadingCategories] = useState(true);
    const isMounted = useIsMounted();

    /**
     * Redirects the operator to the lookup search section
     * @param event {MouseEvent}
     * @param newValue {number}
     */
    const onTabClick = (event, newValue) => {
        setTab(newValue);
    }

    /**
     * Sets the categories state with the given value if the component is still mounted.
     * @type {(function(*): void)|*}
     */
    const setCategoriesFromProductsTab = useCallback((value) => {
        if (isMounted()) {
            setCategories(value)
        }
    }, [isMounted])

    /**
     * Sets the loadingCategories state with the given value if the component is still mounted.
     * @type {(function(*): void)|*}
     */
    const setLoadingCategoriesFromProductsTab = useCallback((value) => {
        if (isMounted()) {
            setLoadingCategories(value)
        }
    }, [isMounted])

    return (
        <>
            <DialogContent className={'px-4 pt-4'}>
                <div className={'w-100'}>
                    <p className={'text-sm'}>
                        This document has been assigned to the following items.
                    </p>
                </div>
                <div className={'flex-grow-1 position-relative'}>
                    <Tabs
                        className={'mt-3'}
                        value={tab}
                        onChange={onTabClick}
                        aria-label="result tabs">
                        <Tab value={0} label={"Products"}/>
                        <Tab value={1} label={"Categories"}/>
                    </Tabs>
                    <div className='w100 my-3'/>
                    <div className={'position-absolute'} style={{top: 0, right: 0}}>
                        <Button
                            variant={'text'}
                            color={'primary'}
                            className={'d-flex align-items-center'}
                            onClick={() => setInAddMode(true)}
                        >
                            <Add className={'mr-2'}/>
                            <p>
                                Assign More Items
                            </p>
                        </Button>
                    </div>
                </div>
                <div className={'mt-4 d-flex flex-column'}>
                    {
                        tab === 0 &&
                        <AssignedItemsListProductsTab
                            technicalFileId={technicalFileId}
                            assign={assign}
                            unAssign={unAssign}
                            setInAddMode={setInAddMode}
                            setCategories={setCategoriesFromProductsTab}
                            setLoadingCategories={setLoadingCategoriesFromProductsTab}
                        />
                    }
                    {
                        tab === 1 &&
                        <AssignedItemsListCategoriesTab
                            assign={assign}
                            unAssign={unAssign}
                            setInAddMode={setInAddMode}
                            categories={categories}
                            setCategories={setCategories}
                            searching={loadingCategories}
                        />
                    }
                </div>
            </DialogContent>
        </>
    );
}

export default AssignedItemsList;
